module.exports = __webpack_public_path__ + "img/Clicks.222b7f1d.svg";